"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalization = exports.LocalizationStore = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _mobx = require("mobx");

var _jed = require("jed");

var _react = require("react");

var _providers = require("./providers");

var _pt_BRJed = _interopRequireDefault(require("@ContextLogic/legostrings/pt_BR.jed.json"));

var _zh_CNJed = _interopRequireDefault(require("@ContextLogic/legostrings/zh_CN.jed.json"));

var _ko_KRJed = _interopRequireDefault(require("@ContextLogic/legostrings/ko_KR.jed.json"));

var _es_LAJed = _interopRequireDefault(require("@ContextLogic/legostrings/es_LA.jed.json"));

var _de_DEJed = _interopRequireDefault(require("@ContextLogic/legostrings/de_DE.jed.json"));

var _fr_FRJed = _interopRequireDefault(require("@ContextLogic/legostrings/fr_FR.jed.json"));

var _it_ITJed = _interopRequireDefault(require("@ContextLogic/legostrings/it_IT.jed.json"));

var _ja_JPJed = _interopRequireDefault(require("@ContextLogic/legostrings/ja_JP.jed.json"));

var _vi_VNJed = _interopRequireDefault(require("@ContextLogic/legostrings/vi_VN.jed.json"));

var _th_THJed = _interopRequireDefault(require("@ContextLogic/legostrings/th_TH.jed.json"));

var _ar_SAJed = _interopRequireDefault(require("@ContextLogic/legostrings/ar_SA.jed.json"));

var _id_IDJed = _interopRequireDefault(require("@ContextLogic/legostrings/id_ID.jed.json"));

var _tr_TRJed = _interopRequireDefault(require("@ContextLogic/legostrings/tr_TR.jed.json"));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LocaleTranslations = {
  en: {},
  up: {},
  zh: _zh_CNJed["default"],
  pt: _pt_BRJed["default"],
  es: _es_LAJed["default"],
  ko: _ko_KRJed["default"],
  fr: _fr_FRJed["default"],
  de: _de_DEJed["default"],
  ja: _ja_JPJed["default"],
  it: _it_ITJed["default"],
  th: _th_THJed["default"],
  vi: _vi_VNJed["default"],
  id: _id_IDJed["default"],
  ar: _ar_SAJed["default"],
  tr: _tr_TRJed["default"]
};
var Locale4Letter = {
  en: "EN-US",
  up: "EN-US",
  zh: "ZH-CH",
  pt: "PT-BR",
  es: "ES-MX",
  ko: "KO-KR",
  fr: "FR",
  de: "DE",
  ja: "JA",
  it: "IT",
  th: "TH",
  vi: "VI",
  id: "ID",
  ar: "AR-SA",
  tr: "TR"
};
var LocalizationStore = (_class = (_temp = /*#__PURE__*/function () {
  function LocalizationStore(_context) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, LocalizationStore);
    this.context = void 0;

    this.formatter = function (str, args) {
      var nonPositionalMatchCount = 0;

      var replacer = function replacer(match, capturedNum) {
        var argIndex = 0;

        if (capturedNum !== undefined) {
          argIndex = capturedNum - 1;
        } else {
          argIndex = nonPositionalMatchCount;
          nonPositionalMatchCount++;
        }

        return args[argIndex] !== undefined ? args[argIndex].toString() : "";
      };

      var sprintfPlaceholderRegex = /%(\d+)\$[ds]|%[ds]/g;
      var result = str.replace(sprintfPlaceholderRegex, replacer);
      var descPlaceholderRegex = /\{%(\d+)=[^{}]+\}/g;
      return result.replace(descPlaceholderRegex, replacer);
    };

    this.i18n = function (format) {
      var jed = _this.jed,
          currentLocale = _this.currentLocale;
      var result = jed.translate(format).fetch();

      for (var _len = arguments.length, formatArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        formatArgs[_key - 1] = arguments[_key];
      }

      result = _this.formatter(result, formatArgs);

      if (currentLocale == "up") {
        return result.toUpperCase();
      }

      return result;
    };

    this.ci18n = function (context, message) {
      context = context.toUpperCase();
      var jed = _this.jed,
          currentLocale = _this.currentLocale;

      if (!context) {
        return _this.i18n(message);
      }

      var result = jed.translate(message).withContext(context).fetch();

      for (var _len2 = arguments.length, formatArgs = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        formatArgs[_key2 - 2] = arguments[_key2];
      }

      result = _this.formatter(result, formatArgs);

      if (currentLocale == "up") {
        return result.toUpperCase();
      }

      return result;
    };

    this.ni18n = function (num, singular, plural) {
      var jed = _this.jed,
          currentLocale = _this.currentLocale;
      var str = jed.translate(singular).ifPlural(num, plural).fetch();

      for (var _len3 = arguments.length, formatArgs = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        formatArgs[_key3 - 3] = arguments[_key3];
      }

      str = _this.formatter(str, formatArgs);

      if (currentLocale == "up") {
        return str.toUpperCase();
      }

      return str;
    };

    this.cni18n = function (context, num, singular, plural) {
      var jed = _this.jed,
          currentLocale = _this.currentLocale;
      context = context.toUpperCase();

      if (!context) {
        return _this.ni18n(num, singular, plural);
      }

      var str = jed.translate(singular).ifPlural(num, plural).withContext(context).fetch();

      for (var _len4 = arguments.length, formatArgs = new Array(_len4 > 4 ? _len4 - 4 : 0), _key4 = 4; _key4 < _len4; _key4++) {
        formatArgs[_key4 - 4] = arguments[_key4];
      }

      str = _this.formatter(str, formatArgs);

      if (currentLocale == "up") {
        return str.toUpperCase();
      }

      return str;
    };

    this.context = _context;
  }

  (0, _createClass2["default"])(LocalizationStore, [{
    key: "currentLocale",
    get: function get() {
      return this.context.locale;
    }
  }, {
    key: "currentLocale4Letter",
    get: function get() {
      var _Locale4Letter$this$c = Locale4Letter[this.currentLocale],
          locale = _Locale4Letter$this$c === void 0 ? this.currentLocale : _Locale4Letter$this$c;
      return locale;
    }
  }, {
    key: "jed",
    get: function get() {
      var currentLocale = this.currentLocale;
      var _LocaleTranslations$c = LocaleTranslations[currentLocale],
          jedConfiguration = _LocaleTranslations$c === void 0 ? {} : _LocaleTranslations$c;

      if (Object.keys(jedConfiguration).length == 0) {
        return new _jed.Jed({});
      } // po2json inserts nulls inside the entries arrays so instead of
      // "My string": ["translation"], we get "My string": [null, "translation"]
      // Take out the nulls, before sending the object to Jed()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any


      var polishedJedConfiguration = _objectSpread({}, jedConfiguration);

      for (var _i = 0, _Object$keys = Object.keys(polishedJedConfiguration.locale_data.wish); _i < _Object$keys.length; _i++) {
        var string = _Object$keys[_i];
        var translations = polishedJedConfiguration.locale_data.wish[string];

        if (Array.isArray(translations) && translations.length) {
          polishedJedConfiguration.locale_data.wish[string] = translations.filter(function (_) {
            return _ !== null;
          });
        }
      }

      return new _jed.Jed(polishedJedConfiguration);
    }
  }]);
  return LocalizationStore;
}(), _temp), ((0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currentLocale", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentLocale"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currentLocale4Letter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentLocale4Letter"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "jed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "jed"), _class.prototype)), _class);
exports.LocalizationStore = LocalizationStore;

var useLocalization = function useLocalization() {
  var context = (0, _react.useContext)(_providers.LegoContext);
  return (0, _react.useMemo)(function () {
    return new LocalizationStore(context);
  }, [context]);
};

exports.useLocalization = useLocalization;